export default {"src":"/_next/static/image/public/images/ic_credit_card_grey_vertical_menu.172cbe30e244d86badfe56cca8f7e734.svg","height":20,"width":20};